// Chapter summaries and key content for The King's Return
// Due to size, this contains chapter structures. Full content rendered in components.

export const chapters = {
  0: {
    id: 0,
    title: "Prologue",
    subtitle: "The Simple Clarity of Scripture",
    accessLevel: "free",
    slug: "prologue"
  },
  1: {
    id: 1,
    title: "Chapter One",
    subtitle: "The Four Corner Pieces",
    accessLevel: "seeker",
    slug: "chapter-1",
    cornerPieces: [
      {
        id: 1,
        title: "Corner Piece One",
        passage: "2 Thessalonians 2:1–3",
        anchor: "The Gathering Cannot Happen Until..."
      },
      {
        id: 2,
        title: "Corner Piece Two",
        passage: "Matthew 24:29–31",
        anchor: "Immediately After the Tribulation"
      },
      {
        id: 3,
        title: "Corner Piece Three",
        passage: "1 Corinthians 15:51–52",
        anchor: "At the Last Trumpet"
      },
      {
        id: 4,
        title: "Corner Piece Four",
        passage: "Revelation 20:4–6",
        anchor: "This Is the First Resurrection"
      }
    ]
  },
  2: {
    id: 2,
    title: "Chapter Two",
    subtitle: "The Architecture of Revelation",
    accessLevel: "berean",
    slug: "chapter-2",
    topics: ["Recapitulation", "Seven Seals", "Seven Trumpets", "Seven Bowls"]
  },
  3: {
    id: 3,
    title: "Chapter Three",
    subtitle: "The Prerequisites - The Fall Feasts",
    accessLevel: "berean",
    slug: "chapter-3",
    topics: ["Day of Trumpets", "Day of Atonement", "Feast of Tabernacles", "Tekiah Gedolah"]
  },
  4: {
    id: 4,
    title: "Chapter Four",
    subtitle: "The Border Pieces",
    accessLevel: "berean",
    slug: "chapter-4",
    borderPieces: 6
  },
  5: {
    id: 5,
    title: "Chapter Five",
    subtitle: "The Four Witnesses",
    accessLevel: "berean",
    slug: "chapter-5"
  },
  6: {
    id: 6,
    title: "Chapter Six",
    subtitle: "The Verdict",
    accessLevel: "berean",
    slug: "chapter-6"
  },
  7: {
    id: 7,
    title: "Chapter Seven",
    subtitle: "Why We Missed It",
    accessLevel: "berean",
    slug: "chapter-7"
  },
  8: {
    id: 8,
    title: "Chapter Eight",
    subtitle: "Seventeen Simple Witnesses",
    accessLevel: "berean",
    slug: "chapter-8",
    witnesses: 17
  },
  closing: {
    id: 'closing',
    title: "Closing Chapter",
    subtitle: "Who You Really Are",
    accessLevel: "berean",
    slug: "closing"
  },
  backMatter: {
    id: 'back-matter',
    title: "Back Matter",
    subtitle: "A Final Word & Main Points",
    accessLevel: "berean",
    slug: "back-matter"
  }
};

export const bookConfig = {
  totalChapters: 11, // 8 chapters + prologue + closing + back matter
  freeChapters: [0], // Prologue
  seekerChapters: [0, 1], // Prologue + Chapter 1
  bereanChapters: [0, 1, 2, 3, 4, 5, 6, 7, 8, 'closing', 'back-matter'] // All
};

export const getAccessibleChapters = (userTier) => {
  if (!userTier) return bookConfig.freeChapters;
  if (userTier === 'seeker') return bookConfig.seekerChapters;
  return bookConfig.bereanChapters; // berean, scholar, church
};

export const canAccessChapter = (chapterId, userTier) => {
  const accessible = getAccessibleChapters(userTier);
  return accessible.includes(chapterId);
};
